import {NgOptimizedImage} from "@angular/common";
import {Component} from "@angular/core";
import {NavbarComponent} from "../../layout/navbar/navbar.component";
import {NewsCardsComponent} from "../news/news-card/news-cards.component";
import {ProjectSliderComponent} from "../projects/project-slider/project-slider.component";
import {ServicesBlockComponent} from "../services/services-block/services-block.component";

interface SlideshowImage {
  readonly id: number;
  readonly image: string;
  readonly alt: string;
}

@Component({
  selector: "app-home",
  templateUrl: "./home.component.html",
  styleUrl: "./home.component.scss",
  imports: [
    NgOptimizedImage,
    NavbarComponent,
    ServicesBlockComponent,
    ProjectSliderComponent,
    NewsCardsComponent,
  ],
})
export class HomeComponent {
  protected readonly images: readonly SlideshowImage[] = [
    {
      id: 1,
      image: "assets/images/slideshow-1432501.webp",
      alt: $localize`Blutdruck Log`,
    },
    {
      id: 2,
      image: "assets/images/slideshow-1432667.webp",
      alt: $localize`iLosungen`,
    },
    {
      id: 3,
      image: "assets/images/slideshow-1432658.webp",
      alt: $localize`Telekom Kundencenter App`,
    },
  ];

  protected scrollTo(element: HTMLElement): void {
    element.scrollIntoView({behavior: "smooth", block: "start", inline: "nearest"});
  }
}
